/**
 * VESTA MkII constants — Wx_Linked_FireBehaviourCalcs_Australia v13.5.
 */

import {DEFAULT_SUMMER_AFTERNOON_FMC} from '../shared/ffm';

export const FOREST_TYPE = {
  DRY: 'dry',
  WET: 'wet'
};

export const DEFAULT_WRF = {
  [FOREST_TYPE.DRY]: 3,
  [FOREST_TYPE.WET]: 5
};

// MkII surface load at hazard 3.5 = 14 t/ha (VESTA uses 16).
export const SURFACE_FUEL_LOADS = { '4': 20, '3.5': 14, '3': 12, '2': 8, '1': 4, '0': 0 };
export const NEAR_SURFACE_FUEL_LOADS = { '4': 4, '3.5': 3.5, '3': 3, '2': 2, '1': 1, '0': 0 };
export const ELEVATED_FUEL_LOADS = { '4': 6, '3.5': 4, '3': 3, '2': 2, '1': 1, '0': 0 };
export const BARK_FUEL_LOADS = { '4': 7, '3.5': 6, '3': 5, '2': 2, '1': 1, '0': 0 };

export const DEFAULT_VARIABLES_DRY = {
  forest_type: FOREST_TYPE.DRY,
  lag_temp_rh: 0,
  summer_afternoon_fmc: DEFAULT_SUMMER_AFTERNOON_FMC,
  slope: 0,
  surface_hazard: 3,
  near_surface_hazard: 3,
  near_surface_height: 25,
  elevated_hazard: 2,
  elevated_height: 1.5,
  bark_hazard: 3,
  wind_reduction_factor: DEFAULT_WRF[FOREST_TYPE.DRY],
  overstorey_cover: 35,
  overstorey_height: 18,
  tall_understorey_cover: 0,
  aspect: 120,
  slope_steepness: 0
};

export const DEFAULT_VARIABLES_WET = {
  forest_type: FOREST_TYPE.WET,
  lag_temp_rh: 0,
  summer_afternoon_fmc: DEFAULT_SUMMER_AFTERNOON_FMC,
  slope: 0,
  surface_hazard: 3.5,
  near_surface_hazard: 3.5,
  near_surface_height: 50,
  elevated_hazard: 3.5,
  elevated_height: 2.0,
  bark_hazard: 3.5,
  wind_reduction_factor: DEFAULT_WRF[FOREST_TYPE.WET],
  overstorey_cover: 50,
  overstorey_height: 50,
  tall_understorey_cover: 30,
  aspect: 120,
  slope_steepness: 0
};



// WEBPACK FOOTER //
// ./src/utils/behaviour_models/vesta_mk2/constants.js